import { Title } from '@olist/design-system';
import styled, { css } from 'styled-components';

const Container = styled.div.attrs({
    placeholder: 'pagelayout',
})(() => css `
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 1280px;
    padding: 0 15px;
    width: 100%;

    ${Title} {
      margin-bottom: 8px;
    }
  `);

export { Container };
